import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import Error from "components/generales/Error";
import Boton from "components/boton/Boton";
import axios from "axios";
import "components/generales/Styles.css";
import Spinner from "components/generales/Spinner";

const FormularioCuentas = ({ cuenta, cargando }) => {
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);
  const [tipoWallet, setTipoWallet] = useState(false);
  const [otroTipo, setOtroTipo] = useState(false);
  const navigate = useNavigate();

  // const eth = /0x[a-fA-F0-9]{40}/g;
  // const btc = /([13]|bc1)[A-HJ-NP-Za-km-z1-9]{27,39}/;

  const nuevaCuentaSchema = Yup.object().shape({
    nombre: Yup.string().required("El nombre de cuenta es obligatorio"),
    tipo_cuenta: Yup.string().required("El tipo de cuenta es obligatorio"),
    clave_publica: Yup.string(), // aceptar numeros y letras
    numero_cuenta: Yup.number()
      .integer("Numero no valido")
      .positive("Numero no valido")
      .typeError("Solo valores númericos"),
    cve: Yup.number()
      .integer("Número no valido")
      .positive("Número no valido")
      .typeError("Solo valores númericos"),
    saldo: Yup.number()
      .positive("Saldo no valido")
      .typeError("Solo valores númericos")
      .required("El saldo actual es obligatorio"),
    fecha_corte: Yup.date().required("La fecha de corte es obligatoria"),
  });
  const handleSubmit = async (valores) => {
    try {
      //Se realizará una comparación para verificar cuándo se está editando y cuándo se está registrando una cuenta nueva
      if (cuenta.id_cuenta) {
        //Este código permite guardar la modificación de una cuenta
        const token = localStorage.getItem("token");
        const url = `https://mymoney5.herokuapp.com/cuentas/${cuenta.id_cuenta}`;
        /* const id = localStorage.getItem("id"); */
        const body = JSON.stringify({
          id_cuenta: cuenta.id_cuenta,
          nombre: valores.nombre,
          tipo_cuenta: valores.tipo_cuenta,
          /* clave_publica: valores.clave_publica, */
          numero_cuenta: valores.numero_cuenta,
          cve: valores.cve,
          saldo: valores.saldo,
          fecha_corte: new Date(valores.fecha_corte).toISOString(),
          status: true,
        });
        console.log(body);
        const params = {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        };
        const { status } = await axios.put(url, body, params, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (status === 200) {
          setSuccess(true);
          navigate("/cuentas");
          return;
        }
      } else {
        //Este código permite almacenar una cuenta nueva
        const token = localStorage.getItem("token");
        const url = "https://mymoney5.herokuapp.com/cuentas/";
        const { status } = await axios.post(url, valores, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (status === 200) {
          setSuccess(true);
          navigate("/cuentas");
          return;
        }
        setSuccess(false);
      }
    } catch (error) {
      setError(true);
      return;
    }
    setError(false);
  };
  return cargando ? (
    <Spinner />
  ) : (
    <Formik
      initialValues={{
        nombre: cuenta?.nombre ?? "",
        tipo_cuenta: cuenta?.tipo_cuenta ?? "",
        clave_publica: cuenta?.numero_cuenta ?? "",
        numero_cuenta: cuenta?.numero_cuenta ?? "",
        cve: cuenta?.cve ?? "",
        saldo: cuenta?.saldo ?? "",
        fecha_corte: cuenta?.fecha_corte
          ? new Date(cuenta?.fecha_corte).toISOString().slice(0, 10)
          : "",
        status: true,
      }}
      enableReinitialize={true}
      onSubmit={async (values, { resetForm }) => {
        let currentValues = values;
        if (values.tipo_cuenta !== "Wallet") {
          currentValues = {
            nombre: values.nombre,
            tipo_cuenta: values.tipo_cuenta,
            numero_cuenta: values.numero_cuenta,
            cve: values.cve,
            saldo: values.saldo,
            fecha_corte: values.fecha_corte,
            status: true,
          };
        } else if (values.tipo_cuenta === "Wallet") {
          currentValues = {
            nombre: values.nombre,
            tipo_cuenta: values.tipo_cuenta,
            numero_cuenta: values.clave_publica,
            cve: values.cve,
            saldo: values.saldo,
            fecha_corte: values.fecha_corte,
            status: true,
          };
        }
        await handleSubmit(currentValues);
        resetForm();
      }}
      validationSchema={nuevaCuentaSchema}
    >
      {({ errors, touched, values }) => {
        return (
          <Form>
            <div className="formulario-input">
              <label htmlFor="nombre">Nombre de la cuenta</label>
              <Field
                id="nombre"
                type="text"
                placeholder="Nombre de la cuenta"
                name="nombre"
              />
              {errors.nombre && touched.nombre ? (
                <Error>{errors.nombre}</Error>
              ) : null}
            </div>

            <div className="formulario-input">
              <label htmlFor="tipo_cuenta">Tipo de cuenta</label>
              <Field component="select" id="tipo_cuenta" name="tipo_cuenta">
                <option value="">Elige el tipo de cuenta</option>
                <option value="Cuenta">Cuenta</option>
                <option value="Ahorro">Ahorro</option>
                <option value="Nomina">Nómina</option>
                <option value="Efectivo">Efectivo</option>
                <option value="Inversion">Inversión</option>
                <option value="Credito">Crédito</option>
                <option value="Wallet">Wallet</option>
                <option value="Departamental">Departamental</option>
                <option value="Vales">Vales</option>
              </Field>
              {errors.tipo_cuenta && touched.tipo_cuenta ? (
                <Error>{errors.tipo_cuenta}</Error>
              ) : null}
              {values.tipo_cuenta === "Wallet"
                ? setTipoWallet(true)
                : setTipoWallet(false)}
              {values.tipo_cuenta !== "Wallet" && values.tipo_cuenta !== ""
                ? setOtroTipo(true)
                : setOtroTipo(false)}
            </div>

            {tipoWallet ? (
              <div className="formulario-input">
                <label htmlFor="clave_publica">Clave Publica</label>
                <Field
                  id="clave_publica"
                  type="text"
                  placeholder="Clave Publica"
                  name="clave_publica"
                  required={true}
                />
                {errors.clave_publica && touched.clave_publica ? (
                  <Error>{errors.clave_publica}</Error>
                ) : null}
              </div>
            ) : null}

            {otroTipo ? (
              <div className="formulario-input">
                <label htmlFor="numero_cuenta">Número de la cuenta</label>
                <Field
                  id="numero_cuenta"
                  type="text"
                  placeholder="Número de cuenta"
                  name="numero_cuenta"
                  required={true}
                />
                {errors.numero_cuenta && touched.numero_cuenta ? (
                  <Error>{errors.numero_cuenta}</Error>
                ) : null}
              </div>
            ) : null}

            <div className="formulario-input">
              <label htmlFor="cve">CVE</label>
              <Field id="cve" type="text" placeholder="CVE" name="cve" />
              {errors.cve && touched.cve ? <Error>{errors.cve}</Error> : null}
            </div>

            <div className="formulario-input">
              <label htmlFor="saldo">Saldo actual</label>
              <Field id="saldo" type="text" placeholder="$" name="saldo" />
              {errors.saldo && touched.saldo ? (
                <Error>{errors.saldo}</Error>
              ) : null}
            </div>

            <div className="formulario-input">
              <label htmlFor="fecha_corte">Fecha de Corte</label>
              <Field
                id="fecha_corte"
                min="2022-01-01"
                value={values.fecha_corte}
                type="date"
              />
              {errors.fecha_corte && touched.fecha_corte ? (
                <Error>{errors.fecha_corte}</Error>
              ) : null}
            </div>

            <Boton>
              {cuenta?.nombre ? "Editar Cuenta" : "Registrar Cuenta"}
            </Boton>

            {success && (
              <div className="formulario-exito">
                <p>Cuenta Registrada</p>
              </div>
            )}

            {error && (
              <div className="formulario-error">
                <p>Ocurrio un error, intenta de nuevo</p>
              </div>
            )}
          </Form>
        );
      }}
    </Formik>
  );
};
FormularioCuentas.defaultProps = {
  cuenta: {},
  cargando: false,
};
export default FormularioCuentas;
